// App.js
import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { useMantineTheme } from '@mantine/core';
import routes from './RouteLink';
import { Toaster } from 'react-hot-toast';

// Exported for the AppearanceProvider in index.jsx: it sits outside RouterProvider and follows
// this router's location to keep /login and /proposalpdf light.
export const router = createBrowserRouter(routes);

// react-hot-toast draws its own white boxes (#fff / #363636); give them the CRM's surfaces so a
// toast is not a white flash in dark mode. Re-rendering updates toasts already on screen.
function ThemedToaster() {
  const theme = useMantineTheme();
  const dark = theme.colorScheme === 'dark';
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        style: {
          background: dark ? theme.colors.dark[6] : theme.white,
          color: dark ? theme.colors.dark[0] : theme.colors.dark[9],
          border: `1px solid ${dark ? theme.colors.dark[4] : theme.colors.gray[2]}`,
          borderRadius: theme.radius.md,
          boxShadow: theme.shadows.md,
          fontFamily: theme.fontFamily,
          fontSize: theme.fontSizes.sm,
        },
      }}
    />
  );
}

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <ThemedToaster />
    </>
  );
}

export default App;
